import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const PackagesService = {
  // Existing login function
  getAllPackages: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllPackages +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllPackagesWithoutPagination: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllPackagesWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deletePackages: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deletePackages,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updatePackagesStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.updatePackagesStatus,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  addPackages: async (
    _id,
    packageName,
    validityInDays,
    actualPrice,
    discountedPrice,
    // featuredImage,
    mainImage,
    mockTestData,
    discountCoordinator,
    details,
    isBharatSAT,
    paidsyllabus,
    ismocktest,
    class_id,
    medium
  ) => {
    try {
      const formData = new FormData();
      formData.append("package_id", _id || "");
      formData.append("packageName", packageName);
      formData.append("validityInDays", validityInDays);
      formData.append("actualPrice", actualPrice);
      formData.append("discountedPrice", discountedPrice);
      formData.append("details", details);
      formData.append("mockTests", mockTestData);
      formData.append("discountCoordinator", discountCoordinator);
      // formData.append("featuredImage", featuredImage);
      formData.append("mainImage", mainImage);
      formData.append("isBharatSAT", isBharatSAT);
      formData.append("paidSyllabus", paidsyllabus);
      formData.append("isMockTest", ismocktest);
      formData.append("class_id", class_id);
      formData.append("medium", medium);

      const response = await axios.post(ApiConstants.addPackages, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      // Handle API errors here
      throw error;
    }
  },
};

export default PackagesService;
